module.exports = __webpack_public_path__ + "img/maxlogo.3a720db2.jpg";